<template>
    <div class="ui-popover-header">
        <slot></slot>
    </div>
</template>
